import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Radio,
} from "@mui/material";
import { orange, brown, cyan, blue } from "@mui/material/colors";
import Iconify from "../iconify/Iconify";
import moment from "moment";
export default function CardsOnSaleTable(props) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Card ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Rating</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Expire At</TableCell>
              <TableCell>On Sale</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.cards?.map((row, index) => {
              const isLast = index === props.cards.length - 1;
              return (
                <TableRow
                  key={index}
                  ref={isLast ? props.lastCardRef : null}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.cardId}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.card?.firstname} {row.card?.lastname}
                  </TableCell>
                  <TableCell component="th" scope="row">

                    <Radio
                      checked={true}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "B" }}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 28,
                        },
                        color: row.card?.cardRating === 1 ? cyan[800] : row.card?.cardRating === 2 ? orange[800] : row.card?.cardRating === 3 ? blue[800] : brown[800],
                        "&.Mui-checked": {
                          color: row.card?.cardRating === 1 ? cyan[600] : row.card?.cardRating === 2 ? orange[600] : row.card?.cardRating === 3 ? blue[600] : brown[600],
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell component="th" scope="row">
                    {row.price}
                  </TableCell>
                  <TableCell>{moment.unix(row.expiresAt).format("ddd MMM D, YYYY h:mm A")}</TableCell>
                  <TableCell component="th" scope="row">
                    {new Date(row.expiresAt * 1000) > new Date() ? (
                      <Iconify
                        icon={"eva:checkmark-circle-2-outline"}
                        sx={{ color: "green" }}
                      />
                    ) : (
                      <Iconify
                        icon={"eva:close-circle-outline"}
                        sx={{ color: "red" }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
